// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"144":"ef51ff5f","492":"f80ecfaa","597":"1b834f1b","789":"e7f7ef00","860":"965d0909"}[chunkId] + ".chunk.css";
};